/**
 * @generated SignedSource<<58d82dfc637fff473b92f115fe8977f7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type LandlordRedressScheme = "PROPERTY_REDRESS_SCHEME" | "THE_PROPERTY_OMBUDSMAN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type DirectoryAgentPage_agent$data = {
  readonly address: string | null | undefined;
  readonly areas: ReadonlyArray<{
    readonly slug: string | null | undefined;
  }> | null | undefined;
  readonly enrichedAt: string | null | undefined;
  readonly googleMapsUrl: string | null | undefined;
  readonly googleRating: number | null | undefined;
  readonly googleReviewCount: number | null | undefined;
  readonly hasClientMoneyProtection: boolean | null | undefined;
  readonly id: string;
  readonly name: string | null | undefined;
  readonly phone: string | null | undefined;
  readonly redressScheme: LandlordRedressScheme | null | undefined;
  readonly services: ReadonlyArray<string> | null | undefined;
  readonly slug: string | null | undefined;
  readonly sources: {
    readonly clientMoneyProtection: ReadonlyArray<string> | null | undefined;
    readonly redressScheme: ReadonlyArray<string> | null | undefined;
    readonly services: ReadonlyArray<string> | null | undefined;
    readonly trustpilot: ReadonlyArray<string> | null | undefined;
  } | null | undefined;
  readonly trustpilotRating: number | null | undefined;
  readonly trustpilotReviewCount: number | null | undefined;
  readonly trustpilotUrl: string | null | undefined;
  readonly website: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"DirectoryFeeBlock_agent">;
  readonly " $fragmentType": "DirectoryAgentPage_agent";
};
export type DirectoryAgentPage_agent$key = {
  readonly " $data"?: DirectoryAgentPage_agent$data;
  readonly " $fragmentSpreads": FragmentRefs<"DirectoryAgentPage_agent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "services",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "redressScheme",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DirectoryAgentPage_agent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "website",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "googleMapsUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "googleRating",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "googleReviewCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "trustpilotUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "trustpilotRating",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "trustpilotReviewCount",
      "storageKey": null
    },
    (v1/*:: as any*/),
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasClientMoneyProtection",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enrichedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LandlordDirectoryAreaReference",
      "kind": "LinkedField",
      "name": "areas",
      "plural": true,
      "selections": [
        (v0/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LandlordDirectoryAgentSources",
      "kind": "LinkedField",
      "name": "sources",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "trustpilot",
          "storageKey": null
        },
        (v1/*:: as any*/),
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "clientMoneyProtection",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DirectoryFeeBlock_agent"
    }
  ],
  "type": "LandlordDirectoryAgent",
  "abstractKey": null
};
})();

(node as any).hash = "0a2b10da4373868913d75492493a5d44";

export default node;
